module.exports = __webpack_public_path__ + "static/media/usuario2.f019e24b.png";